import React, { useMemo } from "react";
import BoardAvatar from "../../atoms/BoardAvatar/BoardAvatar";
import {
  attachmentFromActivityMeta,
  parseActivityMetadata,
} from "../../../app/utils/projectBoard/projectBoardAttachment";
import "./BoardActivityFeed.scss";

const formatActivityTime = (iso) => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

const resolveActor = (item, memberMap) => {
  if (item.actor?.name) return item.actor;
  const member = memberMap.get(Number(item.actorId));
  if (member) return member;
  return {
    id: item.actorId,
    name: "Unknown",
    imageUrl: null,
  };
};

const BoardActivityFeed = ({
  activity = [],
  members = [],
  limit = 10,
  variant = "trello",
  onAttachmentPreview,
}) => {
  const memberMap = useMemo(
    () => new Map(members.map((m) => [Number(m.id || m.userId), m])),
    [members]
  );

  if (!activity.length) {
    return (
      <p className="board-activity-feed__empty">
        No activity yet.
      </p>
    );
  }

  const items = activity.slice(0, limit);

  return (
    <ul className={`board-activity-feed board-activity-feed--${variant}`}>
      {items.map((item) => {
        const actor = resolveActor(item, memberMap);
        const meta = parseActivityMetadata(item.metadata);
        const isAttachment = item.actionType === "attachment";
        const activityAttachment = attachmentFromActivityMeta(item.cardId, meta);
        return (
          <li key={item.activityId} className="board-activity-feed__item">
            <BoardAvatar
              name={actor.name}
              userId={actor.id || actor.userId}
              imageUrl={actor.imageUrl || actor.avatarUrl}
              size="sm"
              className="board-activity-feed__avatar"
            />
            <div className="board-activity-feed__body">
              <p className="board-activity-feed__text">
                <strong className="board-activity-feed__actor">{actor.name}</strong>
                {" "}
                {isAttachment && activityAttachment && onAttachmentPreview ? (
                  <>
                    attached{" "}
                    <button
                      type="button"
                      className="board-activity-feed__link"
                      onClick={() => onAttachmentPreview(activityAttachment)}
                    >
                      {activityAttachment.fileName || item.description?.replace(/^attached\s+/i, "")}
                    </button>
                  </>
                ) : isAttachment && activityAttachment ? (
                  <>attached {activityAttachment.fileName}</>
                ) : (
                  item.description
                )}
              </p>
              {item.createdAt && (
                <time
                  className="board-activity-feed__time"
                  dateTime={item.createdAt}
                >
                  {formatActivityTime(item.createdAt)}
                </time>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default BoardActivityFeed;
